import * as TestUtils from '@gotti/test-utils';
import { sandboxFocusTarget } from '@gotti/sandbox-test';

/**
 * The input-scoping tokens of the clients the running test booted, in `clientIndex` order. The playground scopes a
 * client's keyboard listeners under `inputTokenOf(client)` — unique per client, never an index — so routing a step's
 * key to client `i` means focusing `tokens[i]`. Set by the test booter when it boots, cleared when it tears down; a
 * client a step disconnects loses its token.
 */
let tokens: Array<number | undefined> = [];

export function setTestClientTokens(next: Array<number | undefined>): void {
  tokens = [...next];
}

/** Client `index` disconnected: a press for it reaches no client from now on. */
export function forgetTestClient(index: number): void {
  tokens[index] = undefined;
}

/**
 * Route keyboard input to booted test client `index` only — or, for a client the test never booted or one that
 * disconnected, to no client: the press is a no-op, the same rule the node runner follows (`sandboxFocusTarget`).
 */
export function focusTestClient(index: number): void {
  TestUtils.setFocusedClients([sandboxFocusTarget(tokens, index)]);
}
